import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import { anchor } from '../../utils/func';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { P } from '../../theme/typography';
import utils from '../../utils/utils';

import {
  SectionTitle,
  Section,
  CarouselItem,
  HeadingLine,
} from './css';

const mockData = {
  data: {
    contextItem: { path: '/sitecore/content/internet/home/static-page3', id: '15F3CD38755C525F916C8C4DFE010EE8' },
    datasourceItem: {
      // eslint-disable-next-line max-len
      path: '/sitecore/content/internet/home/static-page3/Page Components/static-page3-jss-staticpage-sections-BCF9D0F7-C09A-5113-8959-E8CE2B49CC98-0-NewsCarousel-6', id: '067B43655BBC51AB8CDAE11006E31F88', heading: { value: 'News' }, anchor: { value: 'news' },
    },
    search: {
      results: {
        items: [{
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE8',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            // eslint-disable-next-line max-len
            description: { value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tincidunt venenatis ullamcorper. Sed imperdiet congue risus, ut aliquam enim vehicula vel. Quisque aliquam bibendum lacus, sed dictum diam fringilla ultrices. In id dui orci. Nam rhoncus leo in tincidunt pellentesque. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean est mauris, placerat at tortor ac, accumsan venenatis ex. Nam pulvinar libero ut blandit tristique. Aliquam dictum lobortis lacinia. Duis finibus congue ligula in vehicula. Curabitur ac fermentum mi. Suspendisse in massa non massa interdum tincidunt nec id felis. Suspendisse dictum urna sed sagittis blandit.\n' },
            heroImage: {
              jss: {
                value: {
                  // eslint-disable-next-line max-len
                  src: 'http://internet.dev.local/-/media/internet/data/media/img/staticpage/staticpage-sample.ashx?h=334&w=1450&hash=0B3CD3B7CD74EB76DBEFEBDE7E9DA175', alt: 'hero', width: '1450', height: '334',
                },
              },
            },
          },
        }],
      },
    },
  },
};

const NewsCarousel = ({ fields }) => {
  const carouselItem = (key, item) => {
    const {
      item: {
        description, heading, heroImage, url,
      },
    } = item;

    return (
      <CarouselItem
        key={key}
        backgroundImageSrc={heroImage && heroImage.jss
    && heroImage.jss.value && heroImage.jss.value.src ? heroImage.jss.value.src : null}
      >
        <div className="content">
          {heading && heading.value
                    && (
                    <>
                      <span className="heading">{heading.value}</span>
                      <HeadingLine />
                    </>
                    )}
          {description && description.value && <P className="text">{description.value.substring(0, 100)}</P>}
          <Link to={url} className="readMore">
            {t('ReadMore')}
            <span className="icon" />
          </Link>
        </div>
      </CarouselItem>
    );
  };

  const localFields = utils.isDisconnected ? mockData : fields;

  const { data: { datasourceItem, drsearch } } = localFields;
  if (!localFields || !localFields.data) {
    // eslint-disable-next-line no-unused-vars
    const errors = localFields != null ? localFields.errors : null;
    return null;
  }

  if (!drsearch) {
    return null;
  }

  const { results: { items } } = drsearch;

  if (!items || items.length === 0) {
    return null;
  }

  const heading = datasourceItem ? datasourceItem.heading : null;

  const id = datasourceItem && datasourceItem.anchor && datasourceItem.anchor.value ? anchor(datasourceItem.anchor.value) : '';

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Section id={id} className="static-section">
      {heading && heading.value
            && (
            <SectionTitle>
              {heading.value}
            </SectionTitle>
            )}
      <Slider className="carousel-items" {...settings}>
        {items && (items.map((item, key) => carouselItem(key, item)))}
      </Slider>
    </Section>
  );
};

NewsCarousel.propTypes = {
  fields: PropTypes.shape({
    data: PropTypes.shape({
      datasourceItem: PropTypes.shape({
        heading: PropTypes.shape({
          value: PropTypes.string,
        }),
        anchor: PropTypes.shape({
          value: PropTypes.string,
        }),
      }),
      drsearch: PropTypes.shape({
        results: PropTypes.shape({
          items: PropTypes.arrayOf(
            PropTypes.shape({
              item: PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                path: PropTypes.string,
                url: PropTypes.string,
                pageTitle: PropTypes.shape({
                  value: PropTypes.string,
                }),
                heading: PropTypes.shape({
                  value: PropTypes.string,
                }),
                description: PropTypes.shape({
                  value: PropTypes.string,
                }),
                heroImage: PropTypes.shape({
                  jss: PropTypes.shape({
                    value: PropTypes.shape({
                      src: PropTypes.string,
                      alt: PropTypes.string,
                      width: PropTypes.string,
                      height: PropTypes.string,
                    }),
                  }),
                }),
              }),
            }),
          ),
        }),
      }),
    }),
  }),
};

export default NewsCarousel;
